import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
import _styled from "@emotion/styled-base";

var getBgColor = function getBgColor(_ref) {
  var theme = _ref.theme;
  return theme.colors.background2;
};

var getColor = function getColor(_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
};

export var Link = _styled("a", {
  target: "etzcnak0"
})("margin:1.25rem 0;padding:1rem;display:flex;justify-content:space-between;text-decoration:none;border:1px solid rgba(0,0,0,0.08);background-color:", getBgColor, ";color:", getColor, ";border-radius:3px;box-shadow:0px 3px 8px 0px rgba(10,25,36,0.1);transition:opacity .2s ease;span:first-of-type{text-decoration:underline;}span:last-of-type{color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray;
}, ";text-decoration:none;}&:hover{opacity:.9;}");

if (typeof Link !== 'undefined' && Link && Link === Object(Link) && Object.isExtensible(Link) && !Link.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Link, '__filemeta', {
    configurable: true,
    value: {
      name: "Link",
      filename: "node_modules/@nejcm/docz-theme-extended/src/components/Ref/styles.js"
    }
  });
}